var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"styleName":"screenWrap"}},[_vm._v("\n  这是屏幕共享\n")])}
var staticRenderFns = []

export { render, staticRenderFns }